const FileUploadExtensions = ["docx",
"doc",
"rtf",
"jpeg",
"jpg",
"jfif",
"gif",
"png",
"pdf",
"pptx",
"ppt",
"xlsx",
"xls",
"csv"];
const ExternalVendorFormsExtensions = ["pdf"];
const ProductFormsExtensions = ["xlsx"];
export {
    FileUploadExtensions, ExternalVendorFormsExtensions, ProductFormsExtensions
};